import {
  CreateTransient,
  theme as defaultTheme,
  Icon,
} from "@mindlercare/ui-web";
import { NavLink } from "react-router-dom";
import { styled, css } from "styled-components";
import { Typography } from "../typography";

type TransientIsDrawerOpen = CreateTransient<{
  isDrawerOpen: boolean;
}>;

const paddingMixin = css`
  padding-left: 32px;
`;

const activeMixin = css`
  &.active {
    background-color: ${defaultTheme.COLORS.BLACK_GREY_OPACITY};
    color: ${defaultTheme.COLORS.GRAY_BLACK};

    & svg {
      fill: ${defaultTheme.COLORS.GRAY_BLACK};
    }
  }
`;

const hoverMixin = css`
  &:hover {
    background-color: ${defaultTheme.COLORS.BLACK_GREY_OPACITY};
    color: ${defaultTheme.COLORS.GRAY_BLACK};

    & svg {
      fill: ${defaultTheme.COLORS.GRAY_BLACK};
    }
  }
`;

const navLinkStyling = css`
  display: flex;
  align-items: center;
  height: 45px;
  text-decoration: none;
  font-style: normal;
  font-family: ${defaultTheme.FONT.FAMILY.BODY};
  background-color: ${defaultTheme.COLORS.GRAY_X_LIGHT};
  color: ${defaultTheme.COLORS.GRAY_DARK};
  font-size: 14px;
  ${paddingMixin}
  ${hoverMixin}
`;

export const StyledContainer = styled.nav<TransientIsDrawerOpen>`
  background-color: ${defaultTheme.COLORS.GRAY_X_LIGHT};
  overflow: hidden;
  padding-top: 24px;
  padding-bottom: 29px;
  width: 90px;
  min-width: 90px;
  height: 100%;
  display: flex;
  flex-direction: column;

  ${({ $isDrawerOpen }) =>
    $isDrawerOpen &&
    css`
      width: 216px;
      min-width: 216px;
    `}

  ${({ $isDrawerOpen }) =>
    !$isDrawerOpen &&
    css`
      display: flex;
      flex-direction: column;
      align-items: center;
    `}
`;

export const StyledLogo = styled(Icon.Logo)<TransientIsDrawerOpen>`
  ${({ $isDrawerOpen }) =>
    $isDrawerOpen &&
    css`
      margin-left: ${defaultTheme.MARGIN.XL};
    `}
`;

export const StyledHeader = styled(Icon.MCLogo)`
  margin-top: 30px;
  margin-left: 32px;
`;

export const StyledNavLinkContainer = styled.div<TransientIsDrawerOpen>`
  padding-top: 65px;
  width: 100%;

  ${({ $isDrawerOpen }) =>
    $isDrawerOpen &&
    css`
      padding-top: 16px;
      & svg {
        margin-right: 12px;
      }
    `}

  & svg {
    fill: ${defaultTheme.COLORS.GRAY_DARK};
  }
`;

export const StyledLinkContainerTitle = styled(Typography)`
  ${paddingMixin}
  font-size: ${defaultTheme.FONT.SIZE.SMALL_MEDIUM};
  font-family: ${defaultTheme.FONT.FAMILY.HEADERS};
  font-weight: ${defaultTheme.FONT.WEIGHT.MEDIUM};
  color: ${defaultTheme.COLORS.GRAY_DARK};
  text-transform: uppercase;
`;

const linkStyling = css<TransientIsDrawerOpen>`
  ${navLinkStyling}
  ${activeMixin}

  ${({ $isDrawerOpen }) =>
    !$isDrawerOpen &&
    css`
      padding: 0;
      justify-content: center;
    `}
`;

export const StyledNavLink = styled(NavLink)<TransientIsDrawerOpen>`
  ${linkStyling}
`;

export const StyledLink = styled.a<TransientIsDrawerOpen>`
  ${linkStyling}
`;

export const StyledToggleButton = styled.button<TransientIsDrawerOpen>`
  ${navLinkStyling}
  border: none;
  cursor: pointer;
  width: 100%;

  ${({ $isDrawerOpen }) =>
    !$isDrawerOpen &&
    css`
      display: flex;
      padding: 0;
      margin: 0;
      justify-content: center;
    `}
`;

export const StyledToggle = styled(Icon.Toggle)``;

export const StyledUserId = styled(Typography)`
  display: block;
`;

export const StyledNavFooter = styled.div<TransientIsDrawerOpen>`
  ${({ $isDrawerOpen }) =>
    $isDrawerOpen &&
    css`
      ${paddingMixin}
    `}

  & svg {
    fill: ${defaultTheme.COLORS.GRAY_DARK};
    cursor: pointer;
  }
  & svg:hover {
    fill: ${defaultTheme.COLORS.GRAY_BLACK};
  }

  margin-top: auto;
`;

export const StyledLogoutButton = styled.button<TransientIsDrawerOpen>`
  border: none;
  cursor: pointer;
  width: 100%;
  font-size: 16px;
  background-color: ${defaultTheme.COLORS.GRAY_X_LIGHT};
  padding-left: 0;
  margin-bottom: 16px;

  ${({ $isDrawerOpen }) =>
    $isDrawerOpen &&
    css`
      text-align: left;
    `}
`;

export const NumberOfNotifications = styled.div`
  color: ${defaultTheme.COLORS.GRAY};
  margin-left: auto;
  margin-right: ${defaultTheme.MARGIN.SM};
`;
